// Verbindet die kuratierten Kacheln (tiles[], Array-Reihenfolge = Anzeige-
// Reihenfolge) mit den WP-Unterseiten der Messe: eine wpPage-Kachel traegt nur
// die Steuerung (state, newTab), Titel/URL/Bild kommen zur Laufzeit aus
// WordPress. Nicht gelistete Seiten erscheinen nicht — wie im Altsystem-
// Repeater (Spec Kachelsteuerung §3/§6). Eine wpPage-Kachel, deren Seite in
// WordPress verschwunden ist, faellt weg: ohne Ziel gibt es nichts zu zeigen.
const joinWpTiles = (tiles, wpPages) => tiles
    .map(tile => {
        if ('wpPage' !== tile.type) return tile
        const page = wpPages.find(p => p.id === tile.wpPageId)
        return page && { ...tile, title: page.title, url: page.url, imageUrl: page.imageUrl }
    })
    .filter(Boolean)

export default joinWpTiles
